import { useCallback, useMemo } from 'react';
import { useStoreActions } from '~/contexts';
import { useMutationState } from '~/hooks/reactQuery/useMutationState';
import { useLocaleKeys } from '~/i18n';
import { buildFullOrder } from './useWorkspaceReorder.utils';
export function useWorkspaceReorder(param) {
    let { workspaces } = param;
    const { api, setWorkspaces, fetchUserInfo } = useStoreActions();
    const { t } = useLocaleKeys('components.navigation.businessSwitcher');
    const { mutate } = useMutationState({
        mutationFn: (fullOrderIds)=>api.user.reorderWorkspaces(fullOrderIds),
        onError: ()=>{
            fetchUserInfo();
        },
        toasts: {
            errorMessage: t.reorderError()
        }
    });
    const reorder = useCallback((displayedNewOrderIds)=>{
        const { fullOrderIds, reorderedWorkspaces } = buildFullOrder(workspaces, displayedNewOrderIds);
        setWorkspaces(reorderedWorkspaces);
        mutate(fullOrderIds);
    }, [
        workspaces,
        setWorkspaces,
        mutate
    ]);
    return useMemo(()=>({
            reorder
        }), [
        reorder
    ]);
}
